module.exports = __webpack_public_path__ + "img/vital.8d4f2589.png";